import Index from './odd';

export default Index;
